import { PlusIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'

import { Button } from '@/components/ui/button'
import {
  BankAccountsTable,
  InvoicingBankAccount,
  useBankAccountDialogs,
} from '@/containers/Settings/BankAccounts/BankAccounts'
import { SettingsPage } from '@/containers/Settings/SettingsLayout'
import { apiFetcher } from '@/data/fetcher'

export default function SettingsBankAccountsPage() {
  const { t: tb } = useTranslation(undefined, { keyPrefix: 'settings.bankAccounts' })

  const { data: bankAccounts, isLoading, mutate } = useSWR<{ data?: InvoicingBankAccount[] }>(
    '/api/v2/bank-accounts',
    apiFetcher,
  )

  const { openCreate, openEdit, askDelete, dialogs } = useBankAccountDialogs(() => mutate())

  const createButton = (
    <Button onClick={openCreate}>
      <PlusIcon />
      {tb('actions.create')}
    </Button>
  )

  return (
    <SettingsPage
      title="Bankovní účty"
      description="Účty, na které vám odběratelé platí. Výchozí účet se předvyplní na nových dokladech."
      breadcrumbHref="/settings/bank-accounts"
      width="list"
      actions={bankAccounts?.data?.length ? createButton : undefined}
    >
      <BankAccountsTable
        bankAccounts={bankAccounts?.data}
        isLoading={isLoading}
        onEdit={openEdit}
        onDelete={askDelete}
        emptyAction={createButton}
      />

      {dialogs}
    </SettingsPage>
  )
}
